export const AREA_LIST_PANELS = {
    AT_RISK: "at-risk",
    PLANNABLE: "plannable",
    PLANNED: "planned",
} as const;

export type AreaListPanelKey = (typeof AREA_LIST_PANELS)[keyof typeof AREA_LIST_PANELS];

export const STATUS_BY_AREA_LIST_PANEL: Record<AreaListPanelKey, string[]> = {
    [AREA_LIST_PANELS.AT_RISK]: ["impossible", "outOfProtocol", "plannableAtRisk"],
    [AREA_LIST_PANELS.PLANNABLE]: ["plannableOk", "plannableSoon"],
    [AREA_LIST_PANELS.PLANNED]: ["planned"],
};

interface AreaListPanelConfig {
    key: AreaListPanelKey;
    translationKey: string;
}

export const AREA_LIST_PANEL_CONFIGS: AreaListPanelConfig[] = [
    {
        key: AREA_LIST_PANELS.AT_RISK,
        translationKey: "areaLists.atRisk",
    },
    {
        key: AREA_LIST_PANELS.PLANNABLE,
        translationKey: "areaLists.plannable",
    },
    {
        key: AREA_LIST_PANELS.PLANNED,
        translationKey: "areaLists.planned",
    },
];
